module.exports = __webpack_public_path__ + "static/media/LINK-AVAX.df4957b8.svg";